import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetFilterIdListResponse,
  GetModelSuiteMonitorConfigsRequestParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (data: GetFilterIdListResponse[]) => ReactElement
  onSuccess?: (data: GetFilterIdListResponse[]) => void
  onError?: (error: Error) => void
  shortErrorMessage?: string
  params?: GetModelSuiteMonitorConfigsRequestParams
}

const GetModelSuiteMonitorConfigsRequest = ({
  children,
  onSuccess,
  onError,
  shortErrorMessage,
  params
}: Props) => {
  const url = `${TEST_CONFIG_SERVICE}/test_configuration_names`

  const { requestParams } = useGetParamsWithSpaceId<GetModelSuiteMonitorConfigsRequestParams | undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetModelSuiteMonitorConfigsRequest
